exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-16dc1352]{margin:0;color:var(--dark-tan);text-transform:uppercase;font-weight:700;font-size:18px}", ""]);

// exports
